import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_HEALTH_INSURANCE = gql`
  query getHealthInsurance($companyId: String!, $queryOptions: QueryOptionsInput) {
    getHealthInsurance(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        name
        healthInsuranceNumbers {
          healthInsuranceNumber
          clientNumbers
        }
        companyId
        createdAt
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetHealthInsurance = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'name', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_HEALTH_INSURANCE, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const healthInsurance = data?.getHealthInsurance || {};

  return {
    collection: healthInsurance?.collection || [],
    loading,
    paginationConfig: {
      total: healthInsurance?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};
